angular
  .module 'shared'
  .directive 'logItemValue', () ->
    restrict: 'E'
    scope:
      value: '='
    template: require('templates/shared/log_item_value.html.slim')
    controller: ($scope) ->
      $scope.isColor = $scope.value?[0] is '#' && $scope.value.length in [4, 7]
